
var checkinputLess = {};
import genaration from '../../utils/classname';
export var checkinputClass = genaration(checkinputLess, 'checkinput');